// src/services/readjudicacionService.js

import {
    readjListarLotesJWT,
    readjObtenerLoteJWT,
    readjObtenerRegistrosJWT,
    readjObtenerMetricasJWT,
    readjAuditarLoteJWT,
    readjEditarRegistroJWT,
    readjExcluirRegistroJWT,
    readjReincluirRegistroJWT,
    readjFinalizarAuditoriaJWT,
    readjEliminarLoteJWT,
    readjObtenerAbogadosJWT,
    readjObtenerJuzgadosJWT,
    readjDesapoderarAbogadosJWT,
    readjFinalizarDesapoderamientoJWT,
    readjAsignarAbogadosJWT,
    readjFinalizarAsignacionJWT,
    readjBuscarAbogadosJWT,
    readjBuscarExpedientesAdmJWT,
    readjGenerarDocumentoJWT,
    readjGenerarDocumentosJWT,
    readjActualizarEstadoJWT,
    readjObtenerCausasAgrupadasJWT,
    readjCrearLoteDesdeExpedientesJWT,
    readjObtenerRegistrosDesapoderarJWT,
    readjObtenerCaracteresJWT,
    readjEnumerarCartasPoderJWT,
    readjObtenerFiscalEstadoJWT,
    readjObtenerRegistrosReciboJWT,
    readjFinalizarReadjudicacionJWT,
    readjObtenerDocumentosGeneradosJWT,
    readjSubirPdfCartaPoderJWT,
    readjGetUrlDescargaPdfJWT,
    readjDescargarPdfBlobJWT,
    readjSubirPdfFirmadoJWT,
    readjListarCartasPendientesFirmaJWT,
    readjObtenerCartaPoderDetalleJWT,
} from '../api/endpoints';

const readjudicacionService = {
    /**
     * Listar lotes con filtros
     * @param {Object} filtros - { estado, fechaDesde, fechaHasta, modulo, busqueda }
     */
    async listarLotes(filtros = {}) {
        try {
            return await readjListarLotesJWT(filtros);
        } catch (error) {
            console.error('Error al listar lotes:', error);
            throw error;
        }
    },

    /**
     * Obtener detalle de un lote
     * @param {String} idLote
     */
    async obtenerLote(idLote) {
        try {
            return await readjObtenerLoteJWT(idLote);
        } catch (error) {
            console.error('Error al obtener lote:', error);
            throw error;
        }
    },

    /**
     * Obtener registros del lote (con filtro opcional)
     * @param {String} idLote
     * @param {Number} tipoOk - null=todos, 0=defectuosos, 1=correctos, 2=pendientes, 3=excluidos
     */
    async obtenerRegistrosLote(idLote, tipoOk = null) {
        try {
            return await readjObtenerRegistrosJWT(idLote, tipoOk);
        } catch (error) {
            console.error('Error al obtener registros del lote:', error);
            throw error;
        }
    },

    /**
     * Obtener métricas del dashboard
     */
    async obtenerMetricas() {
        try {
            return await readjObtenerMetricasJWT();
        } catch (error) {
            console.error('Error al obtener métricas:', error);
            throw error;
        }
    },

    /**
     * Auditar un lote (validar todos los registros)
     * @param {String} idLote
     * @param {Boolean} auditarPares - auditar pares NN
     */
    async auditarLote(idLote, auditarPares = true) {
        try {
            return await readjAuditarLoteJWT(idLote, auditarPares);
        } catch (error) {
            console.error('Error al auditar lote:', error);
            throw error;
        }
    },

    /**
     * Editar un registro del lote
     * @param {Number} idRegistro
     * @param {Object} datos
     */
    async editarRegistro(idRegistro, datos) {
        try {
            return await readjEditarRegistroJWT(idRegistro, datos);
        } catch (error) {
            console.error('Error al editar registro:', error);
            throw error;
        }
    },

    /**
     * Finalizar auditoría del lote
     * @param {String} idLote
     * @param {Number} idExpedienteAdm
     */
    async finalizarAuditoria(idLote, idExpedienteAdm) {
        try {
            return await readjFinalizarAuditoriaJWT(idLote, idExpedienteAdm);
        } catch (error) {
            console.error('Error al finalizar auditoría:', error);
            throw error;
        }
    },

    /**
     * Eliminar un lote
     * @param {String} idLote
     */
    async eliminarLote(idLote) {
        try {
            return await readjEliminarLoteJWT(idLote);
        } catch (error) {
            console.error('Error al eliminar lote:', error);
            throw error;
        }
    },

    /**
     * Obtener abogados del lote (con sus expedientes)
     * @param {String} idLote
     */
    async obtenerAbogadosLote(idLote) {
        try {
            return await readjObtenerAbogadosJWT(idLote);
        } catch (error) {
            console.error('Error al obtener abogados del lote:', error);
            throw error;
        }
    },

    /**
     * Obtener juzgados del lote
     * @param {String} idLote
     */
    async obtenerJuzgadosLote(idLote) {
        try {
            return await readjObtenerJuzgadosJWT(idLote);
        } catch (error) {
            console.error('Error al obtener juzgados del lote:', error);
            throw error;
        }
    },

    /**
     * Desapoderar abogados (cambiar carácter a "Reemplazado")
     * @param {String} idLote
     * @param {String} matricula - matricula del abogado
     * @param {Array<Number>} registrosIds - IDs de registros a desapoderar
     * @param {Array<Number>} caracteres - caracteres a buscar (ej: [3, 8, 26])
     */
    async desapoderarAbogados(idLote, matricula, registrosIds, caracteres = [3, 8, 26]) {
        try {
            return await readjDesapoderarAbogadosJWT(idLote, matricula, registrosIds, caracteres);
        } catch (error) {
            console.error('Error al desapoderar abogados:', error);
            throw error;
        }
    },

    /**
     * Finalizar desapoderamiento
     * @param {String} idLote
     */
    async finalizarDesapoderamiento(idLote) {
        try {
            return await readjFinalizarDesapoderamientoJWT(idLote);
        } catch (error) {
            console.error('Error al finalizar desapoderamiento:', error);
            throw error;
        }
    },

    /**
     * Asignar abogados a registros
     * @param {String} idLote
     * @param {Array<Number>} registrosIds - IDs de registros
     * @param {Number} idAbogado - ID del abogado
     * @param {Number} idCaracter - ID del carácter (ej: 3=apoderado)
     */
    async asignarAbogados(idLote, registrosIds, idAbogado, idCaracter = 3) {
        try {
            return await readjAsignarAbogadosJWT(idLote, registrosIds, idAbogado, idCaracter);
        } catch (error) {
            console.error('Error al asignar abogados:', error);
            throw error;
        }
    },

    /**
     * Finalizar asignación
     * @param {String} idLote
     */
    async finalizarAsignacion(idLote) {
        try {
            return await readjFinalizarAsignacionJWT(idLote);
        } catch (error) {
            console.error('Error al finalizar asignación:', error);
            throw error;
        }
    },

    /**
     * Buscar abogados (para autocomplete)
     * @param {String} busqueda
     */
    async buscarAbogados(busqueda) {
        try {
            return await readjBuscarAbogadosJWT(busqueda);
        } catch (error) {
            console.error('Error al buscar abogados:', error);
            throw error;
        }
    },

    /**
     * Buscar expedientes administrativos (para autocomplete)
     * @param {String} busqueda
     */
    async buscarExpedientesAdm(busqueda) {
        try {
            return await readjBuscarExpedientesAdmJWT(busqueda);
        } catch (error) {
            console.error('Error al buscar expedientes administrativos:', error);
            throw error;
        }
    },

    /**
     * Generar documentos del lote
     * @param {String} idLote
     * @param {String} tipoDocumento - 'caratula', 'carta_poder', 'demanda', 'recibo', 'sobres'
     * @param {Object} configuracion - { orden: 1|2|3, intervaloDesde, intervaloHasta }
     */
    async generarDocumento(idLote, tipoDocumento, configuracion = {}) {
        try {
            const response = await readjGenerarDocumentoJWT(idLote, tipoDocumento, configuracion);

            // El backend devuelve la URL del SSRS para abrir en ventana nueva
            if (response.ok && response.url) {
                window.open(response.url, '_blank');
            }

            return response;
        } catch (error) {
            console.error('Error al generar documento:', error);
            throw error;
        }
    },

    /**
     * Obtener causas agrupadas (para impresión)
     * @param {String} idLote
     */
    async obtenerCausasAgrupadas(idLote) {
        try {
            return await readjObtenerCausasAgrupadasJWT(idLote);
        } catch (error) {
            console.error('Error al obtener causas agrupadas:', error);
            throw error;
        }
    },

    /**
     * Generar múltiples documentos
     * @param {String} idLote
     * @param {Array<String>} tiposDocumentos - Array de tipos: 'CARATULA', 'CARTA_PODER', etc.
     * @param {Object} opciones - { formato, ordenamiento, copias, orientacion, observaciones }
     */
    async generarDocumentos(idLote, tiposDocumentos, opciones = {}) {
        try {
            return await readjGenerarDocumentosJWT(idLote, tiposDocumentos, opciones);
        } catch (error) {
            console.error('Error al generar documentos:', error);
            throw error;
        }
    },

    /**
     * Actualizar estado del lote
     * @param {String} idLote
     * @param {Number} nuevoEstado - 0-5
     */
    async actualizarEstadoLote(idLote, nuevoEstado) {
        try {
            return await readjActualizarEstadoJWT(idLote, nuevoEstado);
        } catch (error) {
            console.error('Error al actualizar estado del lote:', error);
            throw error;
        }
    },

    /**
     * Pasar/Finalizar readjudicación - Ejecuta el pasaje completo
     * @param {String} idLote
     */
    async pasarReadjudicacion(idLote) {
        try {
            return await readjFinalizarReadjudicacionJWT(idLote);
        } catch (error) {
            console.error('Error al pasar readjudicación:', error);
            throw error;
        }
    },

    /**
     * Excluir un registro
     * @param {Number} idRegistro
     */
    async excluirRegistro(idRegistro) {
        try {
            return await readjExcluirRegistroJWT(idRegistro);
        } catch (error) {
            console.error('Error al excluir registro:', error);
            throw error;
        }
    },

    /**
     * Reincluir un registro excluido
     * @param {Number} idRegistro
     */
    async reincluirRegistro(idRegistro) {
        try {
            return await readjReincluirRegistroJWT(idRegistro);
        } catch (error) {
            console.error('Error al reincluir registro:', error);
            throw error;
        }
    },

    /**
     * Crear lote desde expedientes seleccionados
     * @param {Object} datos - { expedientes, idModulo, idReparticion }
     */
    async crearLoteDesdeExpedientes(datos) {
        try {
            return await readjCrearLoteDesdeExpedientesJWT(datos);
        } catch (error) {
            console.error('Error al crear lote:', error);
            throw error;
        }
    },

    /**
     * Obtener registros para desapoderar (filtrados por abogado, juzgado, caracteres)
     * @param {String} idLote
     * @param {Object} filtros - { matricula, idJuzgado, caracteres }
     */
    async obtenerRegistrosDesapoderar(idLote, filtros = {}) {
        try {
            return await readjObtenerRegistrosDesapoderarJWT(idLote, filtros);
        } catch (error) {
            console.error('Error al obtener registros para desapoderar:', error);
            throw error;
        }
    },

    /**
     * Obtener caracteres de abogados
     */
    async obtenerCaracteres() {
        try {
            return await readjObtenerCaracteresJWT();
        } catch (error) {
            console.error('Error al obtener caracteres:', error);
            throw error;
        }
    },

    /**
     * Enumerar cartas poder para un lote
     * @param {String} idLote - ID del lote
     */
    async enumerarCartasPoder(idLote) {
        try {
            return await readjEnumerarCartasPoderJWT(idLote);
        } catch (error) {
            console.error('Error al enumerar cartas poder:', error);
            throw error;
        }
    },

    /**
     * Obtener datos del Fiscal de Estado
     */
    async obtenerFiscalEstado() {
        try {
            return await readjObtenerFiscalEstadoJWT();
        } catch (error) {
            console.error('Error al obtener Fiscal de Estado:', error);
            throw error;
        }
    },

    /**
     * Obtener registros para el recibo agrupados por abogado asignado
     * @param {String} idLote - ID del lote
     */
    async obtenerRegistrosRecibo(idLote) {
        try {
            return await readjObtenerRegistrosReciboJWT(idLote);
        } catch (error) {
            console.error('Error al obtener registros para recibo:', error);
            throw error;
        }
    },

    /**
     * Finalizar readjudicación: procesar expedientes, insertar movimientos y actualizar estado
     * @param {String} idLote - ID del lote
     */
    async finalizarReadjudicacion(idLote) {
        try {
            return await readjFinalizarReadjudicacionJWT(idLote);
        } catch (error) {
            console.error('Error al finalizar readjudicación:', error);
            throw error;
        }
    },

    /**
     * Obtener documentos generados de un lote
     * @param {String} idLote - ID del lote
     * @param {String} tipo - Opcional: 'RECIBO', 'CARTA_PODER'
     */
    async obtenerDocumentosGenerados(idLote, tipo = '') {
        try {
            return await readjObtenerDocumentosGeneradosJWT(idLote, tipo);
        } catch (error) {
            console.error('Error al obtener documentos generados:', error);
            throw error;
        }
    },

    // ==================== FIRMA DIGITAL CARTAS PODER ====================

    /**
     * Subir PDF de Carta Poder generado desde el frontend
     * @param {Number} idEscrito - ID del escrito en Readjudicacion_Escritos_Generados
     * @param {Blob} pdfBlob - Archivo PDF como Blob
     */
    async subirPdfCartaPoder(idEscrito, pdfBlob) {
        try {
            return await readjSubirPdfCartaPoderJWT(idEscrito, pdfBlob);
        } catch (error) {
            console.error('Error al subir PDF de carta poder:', error);
            throw error;
        }
    },

    /**
     * Obtener URL para descargar PDF de Carta Poder
     * @param {Number} idEscrito - ID del escrito
     * @param {Boolean} firmado - true para PDF firmado, false para sin firmar
     */
    getUrlDescargaPdf(idEscrito, firmado = false) {
        return readjGetUrlDescargaPdfJWT(idEscrito, firmado);
    },

    /**
     * Descargar PDF de Carta Poder como Blob (con autenticación JWT)
     * @param {Number} idEscrito - ID del escrito
     * @param {Boolean} firmado - true para PDF firmado, false para sin firmar
     * @returns {Promise<Blob>} Blob del PDF
     */
    async descargarPdfBlob(idEscrito, firmado = false) {
        try {
            return await readjDescargarPdfBlobJWT(idEscrito, firmado);
        } catch (error) {
            console.error('Error al descargar PDF:', error);
            throw error;
        }
    },

    /**
     * Subir PDF firmado de Carta Poder
     * @param {Number} idEscrito - ID del escrito en Readjudicacion_Escritos_Generados
     * @param {File|Blob} pdfFile - Archivo PDF firmado
     */
    async subirPdfFirmado(idEscrito, pdfFile) {
        try {
            return await readjSubirPdfFirmadoJWT(idEscrito, pdfFile);
        } catch (error) {
            console.error('Error al subir PDF firmado:', error);
            throw error;
        }
    },

    /**
     * Listar Cartas Poder con estado de firma
     * @param {String} idLote - ID del lote (opcional)
     * @param {Boolean} soloSinFirmar - Solo mostrar pendientes de firma
     */
    async listarCartasPendientesFirma(idLote = null, soloSinFirmar = false) {
        try {
            return await readjListarCartasPendientesFirmaJWT(idLote, soloSinFirmar);
        } catch (error) {
            console.error('Error al listar cartas pendientes de firma:', error);
            throw error;
        }
    },

    /**
     * Obtener detalle de una Carta Poder específica
     * @param {Number} idEscrito - ID del escrito
     */
    async obtenerCartaPoderDetalle(idEscrito) {
        try {
            return await readjObtenerCartaPoderDetalleJWT(idEscrito);
        } catch (error) {
            console.error('Error al obtener detalle de carta poder:', error);
            throw error;
        }
    }
};

export default readjudicacionService;
